import React from 'react';
import { Eye } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from 'src/lib/utils';

/**
 * The "you may look, not touch" indicator a covering editor sees on a request
 * assigned to someone else (#2653). Rendered in place of a composer or action
 * bar rather than layered over it, so nothing interactive is left underneath.
 */
const EditorReadOnlyNotice: React.FC<React.ComponentProps<'div'>> = ({ className, ...props }) => {
  const { t } = useTranslation();

  return (
    <div
      {...props}
      className={cn(
        'tw-flex tw-items-center tw-justify-center tw-gap-2 tw-bg-brand-200/90 tw-p-4 tw-text-center tw-font-medium tw-text-text-strong',
        className,
      )}
    >
      <Eye size={16} className={'tw-shrink-0'} />
      {t('View only — this request is assigned to another editor')}
    </div>
  );
};

/**
 * The compact form, for sitting next to a title or in a toolbar row.
 */
const EditorReadOnlyBadge: React.FC<React.ComponentProps<'span'>> = ({ className, ...props }) => {
  const { t } = useTranslation();

  return (
    <span
      {...props}
      title={t('This request is assigned to another editor — you can watch it, but not change it')!}
      className={cn(
        'tw-flex tw-items-center tw-gap-1.5 tw-rounded-md tw-bg-brand-200 tw-px-2 tw-py-1 tw-text-sm tw-font-medium tw-text-text-strong',
        className,
      )}
    >
      <Eye size={14} className={'tw-shrink-0'} />
      {t('View only')}
    </span>
  );
};

export { EditorReadOnlyNotice, EditorReadOnlyBadge };
